import { useCallback, useRef, useState } from 'react';
import { machineRepairKey, normalizeRNMachineRepairs, RNMachineRepair, RNMachineRepairField } from '../types/rnMachineRepairs';

export const useRNMachineRepairs = () => {
  const [machineRepairs, setMachineRepairsState] = useState<RNMachineRepair[]>([]);
  const machineRepairsRef = useRef<RNMachineRepair[]>([]);

  const setMachineRepairs = useCallback((next: RNMachineRepair[]) => {
    const normalized = normalizeRNMachineRepairs(next);
    machineRepairsRef.current = normalized;
    setMachineRepairsState(normalized);
  }, []);

  const clearMachineRepairs = useCallback(() => setMachineRepairs([]), [setMachineRepairs]);

  // GMP invalidation: editing repairText/repairDate/repairBy on an already-approved row
  // clears all four approval fields locally too — a signature must never sit on data the
  // signer did not see. The server does the same on save. Mirrors OSRazmerTable's
  // patchActual pattern for Работел/Проверил (see components/OSRazmerTable.tsx).
  const updateMachineRepair = useCallback((subprocessId: string, machineId: string, field: RNMachineRepairField, value: string) => {
    const key = machineRepairKey(subprocessId, machineId);
    const current = machineRepairsRef.current;
    const index = current.findIndex((repair) => machineRepairKey(repair.subprocessId, repair.machineId) === key);
    const invalidateApproval = index >= 0 && current[index].approved
      ? { approved: false, approvedBy: null, approvedByName: '', approvedAt: null }
      : {};
    const next = index >= 0
      ? current.map((repair, i) => (i === index ? { ...repair, ...invalidateApproval, [field]: value } : repair))
      : [...current, { subprocessId, machineId, repairText: '', repairDate: '', repairBy: '', approved: false, [field]: value }];
    setMachineRepairs(next);
  }, [setMachineRepairs]);


  return { machineRepairs, machineRepairsRef, setMachineRepairs, clearMachineRepairs, updateMachineRepair };
};
